const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  bindUrl ({ state, commit, rootState }, params) {
    return rootState.axios.get('/qimen/v1frontend/delivery-user/bind-url', { params })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
